import React, { FC } from "react";
import { Box } from "../../../../../components/box";
import { useGetDetailRequests } from "../hooks";
import { Skeleton } from "antd";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import { DETAIL } from "../constant";


export const ExportInformation: FC = () => {
  const { data, isLoading } = useGetDetailRequests();
  if (isLoading) return <Skeleton />;

  return (
    <Box title="Thông tin bảng đăng ký nhân sự tham gia khóa học">
      <div className="list">
        <div className="item">
          <div className="horizontal-content smColumn">
            <p className="w-100">Họ và tên người yêu cầu</p>
            <strong>{data.createdBy.user.displayName}</strong>
          </div>
        </div>

        {
          DETAIL.information.map(value => {

            return <div className="item">
            <div className="horizontal-content smColumn">
              <p className="w-100">{value.label}</p>
              <strong>{data.fields?.[value.field]}</strong>
            </div>
          </div>
          })
        }

        <div className="item">
          <div className="horizontal-content smColumn">
            <p className="w-100">Ngày</p>
            <strong>
              {getDDMMYYYFormat(data.fields.eCourseDate)} -{" "}
              {getDDMMYYYFormat(data.fields.eCourseDateEnd)}
            </strong>
          </div>
        </div>
      </div>
    </Box>
  );
};
